module.exports = __webpack_public_path__ + "static/media/fitness_image.2de9f302.png";